import { render, staticRenderFns } from "./DishDetail.vue?vue&type=template&id=b3c85d74&scoped=true&"
import script from "./DishDetail.vue?vue&type=script&lang=js&"
export * from "./DishDetail.vue?vue&type=script&lang=js&"
import style0 from "./DishDetail.vue?vue&type=style&index=0&id=b3c85d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c85d74",
  null
  
)

export default component.exports